import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.png'
import _imports_1 from '../../assets/img/logo-white.png'
import _imports_2 from '../../assets/img/icons/sidebar-menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-236681f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "navbar navbar-expand-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_1,
  alt: "logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-option d-lg-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "search-btn",
      "data-bs-toggle": "modal",
      "data-bs-target": "#searchModal"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "ri-search-line" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-toggler",
    "data-bs-toggle": "offcanvas",
    href: "#navbarOffcanvas",
    role: "button",
    "aria-controls": "navbarOffcanvas"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
      /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
    ])
  ])
], -1))
const _hoisted_6 = { class: "collapse navbar-collapse" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "sidebar-toggler",
  "data-bs-toggle": "offcanvas",
  href: "#navbarOffcanvas",
  role: "button",
  "aria-controls": "navbarOffcanvas"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Image"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_1,
  alt: "logo"
}, null, -1))
const _hoisted_10 = { class: "navbar-nav" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-option d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "option-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://thetinyleaves.com/thetinyleaves-menu.pdf",
      target: "_blank",
      class: "btn-one"
    }, "Download Menu")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['navbar-area', { sticky: _ctx.isSticky }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "navbar-brand d-lg-none",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_router_link, {
            class: "navbar-brand mx-auto",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Home ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: "/about",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" About Us ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/menu-classic",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Menu ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/contact",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Contact ")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_15
        ])
      ])
    ])
  ], 2))
}